import { Holiday } from './../models/holiday';
import { GoogleCalendarHolidayService } from './../service/google-calendar-holiday.service';
import { Component, OnInit, Output, EventEmitter, Input, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { VrcCalendarEventsService } from '../service/vrc-calendar-events.service';
import { VrCalendarPosition } from '../models/vr-calendar-position';

import * as _moment from 'moment';

_moment.locale('pt-br');
const moment = _moment;

@Component({
  selector: 'vrc-calendar',
  templateUrl: './vrc-calendar.component.html',
  styleUrls: ['./vrc-calendar.component.scss'],
  providers: [DatePipe]
})
export class VrcCalendarComponent implements OnInit, AfterViewInit {
  @ViewChild('calendarContainer') calendarContainerRef!: ElementRef;
  @ViewChild('calendar') calendarRef!: ElementRef;

  @Input() useNonWorkingDays = false;
  @Input() datepicker!: HTMLDivElement;

  @Output() emitSelectDate = new EventEmitter();
  @Output() emitCloseCalendar = new EventEmitter();

  days: any = [];
  isOpen = false;

  events: { day: number, event: string, type: string }[] = [];
  nonWorkingDays: any[] = [];

  private year!: number;
  private month!: number;
  private _currentDate!: any;

  private holidays: Holiday[] = [];

  private readonly classCalendarTop = 'calendar-container--top';
  constructor(
    private pipe: DatePipe,
    private gcHolidaySevice: GoogleCalendarHolidayService,
    private vrCalendarService: VrcCalendarEventsService
  ) {
    this.closeOnKeydownEscape();
  }

  @Input() set open(isOpen: boolean) {
    if (this.calendarRef && isOpen) {
      setTimeout(() => {
        this.openCalendar();
        this.isOpen = isOpen;
        this.initCalendar();
      });
    }
  }

  @Input() set currentDate(date: any) {
    let currentDate = moment(date, 'DD/MM/YYYY');
    if (!currentDate.isValid()) {
      const today = moment();
      currentDate = today;
    }
    this.initCalendar(currentDate);
  }

  get currentDate(): any {
    return this._currentDate;
  }

  get calendarElement(): HTMLElement {
    return this.calendarRef.nativeElement as HTMLElement;
  }

  get calendarContainerElement(): HTMLElement {
    return this.calendarContainerRef.nativeElement as HTMLElement;
  }

  ngOnInit(): void {
    this.initCalendar();
    this.getHolidays(this.year);
    this.getNonWorkingDays(this.year);
    this.setEvents();
  }

  ngAfterViewInit(): void {
    if (this.calendarContainerRef) {
      this.setPosition();
    }
  }

  private openCalendar(): void {
    this.setPosition();
  }

  setPosition(): void {
    const calendarPosition = new VrCalendarPosition();
    calendarPosition.classCssTop = this.classCalendarTop;
    calendarPosition?.setPosition(this.calendarContainerElement);
  }

  initCalendar(currentDate = this.currentDate): void {
    const today = moment();
    const date = currentDate ? currentDate : today;

    const m = this.pipe.transform(date, 'MM') ?? '1';
    const y = this.pipe.transform(date, 'yyyy') ?? '2000';

    this.month = Number.parseInt(m, 10);
    this.year = Number.parseInt(y, 10);

    this.month--;
    this.days = this.weekDays(this.month, this.year);
    this._currentDate = moment(date, 'DD/MM/YYYY');
  }

  private weekDays(month: number, year: number): any {
    const endDate = moment().date(0).month(month).year(year);
    const daysOfMonth = Array(endDate.date()).fill(0).map((_, i) => moment().date(i + 1).month(month).year(year))
      .map((day) => ({ day, week: day.week() }))
      .filter(({ week }, i, arr) => arr.findIndex((info) => info.week === week) === i)
      .map(({ day, week }) => ({
        week, days: Array(7).fill(0).map((_, i) =>
          moment(day).week(week).startOf('week').add(i, 'day'))
      }));
    return this.createCalendar(daysOfMonth);
  }

  private createCalendar(weeks: any): any {
    const calendar = [];
    for (let w = 0; w < weeks.length; w++) {
      for (let d = 0; d < weeks[w].days.length; d++) {
        const date = weeks[w].days[d];
        let classe = '';
        if (this.isCurrentDate(date)) {
          classe += 'current-date ';
        }

        if (this.isItMonthDay(date)) {
          classe += 'other-month ';
        }

        if (this.isNonWorkingDay(date)) {
          classe += 'non-working ';
        } else if (this.isHoliday(date)) {
          classe += 'holiday ';
        }

        if (this.isToday(date)) {
          classe += 'today';
        }

        calendar.push({
          day: date.format('D'),
          class: classe
        });
      }
    }
    return calendar;
  }

  get mothName(): string {
    const months = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio',
      'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

    return months[this.month];
  }

  get currentYear(): number {
    return this.year;
  }

  isToday(date: any): boolean {
    const dateToCompare = moment(date);
    const today = moment(new Date());
    return dateToCompare.startOf('day').isSame(today.startOf('day'));
  }

  isCurrentDate(date: any): boolean {
    const dateToCompare = date;
    const currentDate = moment(this.currentDate, 'DD/MM/YYYY');
    return dateToCompare.startOf('day').isSame(currentDate.startOf('day'));
  }

  isItMonthDay(date: any): boolean {
    const m = date.format('M');
    const month = m != null ? Number.parseInt(m, 10) : 0;

    return (month !== this.month + 1);
  }

  nextMonth(): void {
    this.month++;

    if (this.month > 11) {
      this.year++;
      this.month = 0;
      this.getHolidays(this.year);
      this.getNonWorkingDays(this.year);
    }
    this.days = this.weekDays(this.month, this.year);
    this.setEvents();
  }

  backMonth(): void {
    this.month--;

    if (this.month < 0) {
      this.year--;
      this.month = 11;
      this.getHolidays(this.year);
      this.getNonWorkingDays(this.year);
    }
    this.days = this.weekDays(this.month, this.year);
    this.setEvents();
  }

  reziseDaysItems(calendar: any): boolean {
    return (calendar.length === 42);
  }

  private getHolidays(year: string | number): void {
    this.gcHolidaySevice.getHolidaysYear(year).subscribe((holidays: Holiday[]) => {
      this.holidays = holidays;
    });
  }

  private getNonWorkingDays(year: string | number): any {
    if (this.useNonWorkingDays) {
      this.vrCalendarService.getNonWorkingDays(year).subscribe(nonWorkingDays => {
        this.nonWorkingDays = nonWorkingDays;
      });
    }
  }

  setEvents(): void {
    const holidays = this.getCurrentHolidays();
    const nonWorkingDays = this.getCurrentNonWorkingDays();

    let events: { day: number, event: string, type: string }[] = [];

    events = this.fillEvents(holidays, events, 'holiday');
    events = this.fillEvents(nonWorkingDays, events, 'non-working');

    this.events = events.sort(this.orderByEvents);
  }

  private fillEvents(
    events: { day: number, event: string }[],
    currentEvents: { day: number, event: string, type: string }[],
    type: string): { day: number, event: string, type: string }[] {

    events.forEach(e => {
      const hasNoEvent = currentEvents.every(current => current.day !== e.day);
      if (hasNoEvent) {

        const currentEvent = {
          day: e.day,
          event: e.event,
          type
        };

        currentEvents.push(currentEvent);
      } else {
        currentEvents.filter(current => current.day === e.day).map(current => current.type = type);
      }
    });

    return currentEvents;
  }

  private orderByEvents(
    a: { day: number, event: string, type: string },
    b: { day: number, event: string, type: string }
  ): number {
    if (a.day > b.day) {
      return 1;
    }
    if (a.day < b.day) {
      return -1;
    }
    // a must be equal to b
    return 0;
  }

  getCurrentHolidays(): { day: number, event: string }[] {
    const holidays = this.filterCurrentHolidays();
    return holidays.map(h => {
      return {
        day: moment(h.start.date, 'YYYY-MM-DD').date(),
        event: h.summary ?? ''
      };
    });
  }

  filterCurrentHolidays(): Holiday[] {
    return this.holidays.filter(h => !!h.start?.date && moment(h.start?.date, 'YYYY-MM-DD').month() === this.month);
  }

  getCurrentNonWorkingDays(): { day: number, event: string }[] {
    const nonWorkingDays = this.filterCurrentNonWorkingDays();
    return nonWorkingDays.map(e => {
      return {
        day: moment(e.date, 'DD/MM/YYYY').date(),
        event: e.name ?? ''
      };
    });
  }

  filterCurrentNonWorkingDays(): any[] {
    return this.nonWorkingDays.filter(e => !!e?.date && moment(e?.date, 'DD/MM/YYYY').month() === this.month);
  }

  private isHoliday(date: any): boolean {
    return !!this.getHoliday(date);
  }

  private getHoliday(date: any): Holiday | undefined {
    const dateToCompare = date.format('YYYY-MM-DD');
    const holiday = this.holidays.find(h => h.start.date === dateToCompare);
    return holiday;
  }

  isNonWorkingDay(date: any): boolean {
    return !!this.getNonWorkingDay(date);
  }

  getNonWorkingDay(date: any): Holiday | undefined {
    const dateToCompare = date.format('DD/MM/YYYY');
    const nonWorkingDay = this.nonWorkingDays.find(e => e.date === dateToCompare);
    return nonWorkingDay;
  }

  selectDateOnClick(day: any): void {
    day = String(day).padStart(2, '0');
    const month = String(this.month + 1).padStart(2, '0');
    const dateSelect = `${day}/${month}/${this.year}`;
    this.currentDate = dateSelect;
    this.emitSelectDate.emit(dateSelect);
  }

  closeCalendar(): void {
    this.isOpen = false;
    this.emitCloseCalendar.emit();
  }

  private closeOnKeydownEscape(): void {
    document.body.addEventListener('keydown', (keydownEvent: KeyboardEvent) => {
      if (keydownEvent.code === 'Escape') {
        this.closeCalendar();
      }
    });
  }

}
